import React from "react";
import { connect } from "react-redux";
// import { Field, reduxForm } from "redux-form";
import { reduxForm } from "redux-form";

import { Link, Redirect, withRouter } from "react-router-dom";

import { Form, Button } from "react-bootstrap";

import { withT } from "services/translation/";

import get from "lodash/get";

import {
  loginSuccess,
  loginFailed,
  loginStart,
  loginCancel,
  loginTotp,
  loginTotpFailed,
  loginTotpReset,
  // logoutRequest
} from "services/redux/actions";

import conxtdOut from "apis/conxtdOut";

import LoadingButton from "../LoadingButton";

import ErrorBadge from "../Layout/ErrorBadge";

import "./LoginForm.scss";

class LoginForm extends React.Component {
  state = {
    error: {},
    credentials: {},
    intervalId: null,
    countdownSeconds: 0,
    startCountdown: null,
    resendRequests: 0,
  }

  componentDidMount = () => {
    this.props.dispatch(loginTotpReset());
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { totp } = this.props.user;
    const { startCountdown } = this.state;

    if ((!prevProps.user.totp && totp)) {
      this.setState({ startCountdown: 30 });
    }

    if (!!startCountdown && !prevState.startCountdown) {
      this.setState({ 
        countdownSeconds: startCountdown,
        startCountdown: null,
      });

      const intervalId = setInterval(() => {
        this.setState({ countdownSeconds: this.state.countdownSeconds - 1 });
      }, 1000);
      this.setState({ intervalId });
    }   
  }

  componentWillUnmount() {
    const { intervalId } = this.state;
    if (intervalId) clearInterval(intervalId);
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      error: {}
    });

    if (this.props.user?.totp) {
      // need to submit the totp code for validation
      this.dispatchLoginWithCode({ ...this.state.credentials }, e.target.totp.value);

    } else {
      let credentials = {};

      document.querySelectorAll("#LoginForm input").forEach(item => {
        if (item.name === "confirm_password") return;
        credentials[item.name] = item.value;
      });
      credentials.persist = document.getElementById("persist").checked;

      this.setState({ credentials: credentials});

      // Dispatch login event
      this.dispatchLogin(credentials);
    }
  };

  dispatchLogin = async credentials => {
    const { t } = this.props;

    this.props.dispatch(loginStart());

    // If no env if specified in url path, fallback to default
    const environment = this.props.match.params.env || conxtdOut.defaultEnv;

    try {
      const { user, enterprises, totp, sites } = await conxtdOut.login(
        credentials,
        environment
      );

      if (totp) {
        this.props.dispatch(loginTotp({ totp }));
      } else {
        this.props.dispatch(loginSuccess({ user, enterprises, sites }));
      }      
    } catch (error) {
      const status = get(error.response, "status");
      // 422 unprocessable
      if (status === 422) {
        // this.props.dispatch(
        //   loginFailed({
        //     message: t("errors.incorrect_credentials"),
        //   })
        // );
        if (error.response.data.message.includes("You have tried to login too many times. You can try again in")) {
          const secondsRemaining = parseInt(error.response.data.message.substring(61));

          if (!Number.isNaN(secondsRemaining)) {
            this.setState({
              error: {
                message: error.response.data.message.substring(0, 57),
                timeout: secondsRemaining,
              }
            });
          } else {
            this.setState({
              error: {
                message: t("errors.incorrect_credentials"),
              }
            });
          }
        } else {
          this.setState({
            error: {
              message: error.response.data.message,
            }
          });
        }
        // Destroy session
        conxtdOut.logout();
        // this.props.dispatch(logoutRequest());
      } else {
        // this.props.dispatch(
        //   loginFailed({
        //     message: t("errors.login_failed_x", error.message),
        //   })
        // );
        this.setState({
          error: {
            message: t("errors.login_failed_x", error.message),
          }
        });
      }
      this.props.dispatch(
        loginFailed({}) // now just used to indicate that loading has stopped
      );
    }
  };

  dispatchLoginWithCode = async (credentials, code) => {
    const { t } = this.props;

    this.props.dispatch(loginStart());

    // If no env if specified in url path, fallback to default
    const environment = this.props.match.params.env || conxtdOut.defaultEnv;

    try {
      const { user, enterprises, sites } = await conxtdOut.loginWithCode(
        credentials,
        environment,
        code,
      );
      this.props.dispatch(loginSuccess({ user, enterprises, sites }));
      
    } catch (error) {
      const status = get(error.response, "status");
      // 422 unprocessable
      if (status === 422) {
        if (error.response.data.message.includes("too many times")) {
          const secondsRemaining = parseInt(error.response.data.message.substring(61));

          if (!Number.isNaN(secondsRemaining)) {
            this.setState({
              error: {
                message: error.response.data.message.substring(0, 57),
                timeout: secondsRemaining,
              }
            });
          } else {
            this.setState({
              error: {
                message: t("errors.incorrect_credentials"),
              }
            });
          }

          this.setState({ resendRequests: 0 });
          this.props.dispatch(loginTotpFailed());
        } else {
          this.setState({
            error: {
              message: error.response.data.message,
            }
          });
        }
      } else {
        this.setState({
          error: {
            message: error.response.data.message,
          }
        });
      }
      
      this.props.dispatch(loginCancel());
    }
  }

  render() {
    const { handleFocus, handleBlur, t, user } = this.props;

    // const error = user.error;
    const { error, credentials, countdownSeconds, intervalId, resendRequests } = this.state;

    const session = conxtdOut.getSession();
    const loggedIn = session && session.sessionId;
    const loading = user.loading;
    const totp = user.totp;

    // If no env is specified in url path, fallback to default
    const environment = this.props.match.params.env || conxtdOut.defaultEnv;

    // User is already logged in
    if (loggedIn && !loading) {
      if (user.enterprisesCount > 0 || user.sitesCount === 0) {
        // if the user has access to any enterprises, or has no access to anything, send them to the enterprises page
        return (
          <Redirect
            to={{
              pathname: "/enterprise",
              state: { from: this.props.location }
            }}
          />
        )
      } else {
        // if the user only has access to sites, send them to the sites page
        return (
          <Redirect
            to={{
              pathname: "/sites",
              state: { from: this.props.location }
            }}
          />
        )
      };
    }

    if (countdownSeconds === 0 && intervalId) {
      clearInterval(intervalId);
    }

    let environmentMessage = <>Error: invalid environment</>;
    if (environment && conxtdOut.BASE_URLS[environment]) {
      let switchToLink = "/login/staging";
      let switchToText = "Switch to Staging";
      
      if (environment === "staging") {
        switchToLink = "/login/live";
        switchToText = "Switch to Live";
      } else if (environment === "localhost8765" || environment === "localhost9980") {
        switchToLink = "/login/devbackend";
        switchToText = "Switch to Dev Backend";
      }

      environmentMessage = (
        <>
          Logging in to <b>{environment}</b>
          <Link to={switchToLink} className="waves-link">
            <Button size="sm" className="mx-2">
              {switchToText}
            </Button>
          </Link>
        </>
      );
    }
    let showEnvironment =
      this.props.match.params.env ||
      environment === "staging" ||
      environment === "stagingbackend" ||
      environment === "mars" ||
      environment === "devbackend" ||
      environment === "localhost8765" ||
      environment === "localhost9980"
        ? (
          <div className="alert alert-primary" role="alert">
            {environmentMessage}
          </div>
        )
        : null;

    return (
      <>
        {showEnvironment}
        {error.message && <ErrorBadge message={error.message} timeout={error.timeout} />}
        <Form
          onSubmit={this.handleSubmit}
          onFocus={handleFocus}
          onBlur={handleBlur}
          id="LoginForm"
          className="form-horizontal">
          {
            !totp &&
              <div className="form-group ">
                <Form.Control
                  name="email"
                  component="input"
                  type="email"
                  placeholder={t("email_address_placeholder")}
                />

                <Form.Control
                  name="password"
                  component="input"
                  type="password"
                  placeholder={t("password_placeholder")}
                />
              </div>
          }
          {
            totp &&
              <div className="form-group ">
                <div style={{ width: "100%", fontSize: "20px", fontWeight: "bold" }} className="d-flex justify-content-center">
                  <div>{t("totp_email_message")}</div>
                </div>
                <div className="my-2">{t("totp_code_message")}{credentials.email}</div>
                <Form.Control
                  name="totp"
                  component="input"
                  type="text"
                  placeholder={t("totp_code_placeholder")}
                />
              </div>
          }
          {
            !totp &&
              <div className="form-group row">
                <div className="col-6">
                  <Form.Check
                    type="checkbox"
                    name="persist"
                    id="persist"
                    component="input"
                    label={t("remember_me")}
                  />
                </div>
                <Link className="text-right col-6" to="/reset-password">
                  {t("lost_password")}
                </Link>
              </div>
          }
          <LoadingButton
            type="submit"
            className="btn btn-primary btn-block waves-effect"
            loading={loading}>
            {totp ? t("submit_code") : t("log_in")}
          </LoadingButton>
          {
            totp && 
              <div
                className="mt-4 d-flex justify-content-between align-items-center"
                // style={{ height: "35px" }}
              >
                <div>
                  <Link to="#"
                    onClick={() => {
                      if (intervalId) clearInterval(intervalId);
                      this.setState({ resendRequests: 0 });
                      this.props.dispatch(loginTotpFailed());
                    }}
                  >Back</Link>
                </div>
                {
                  countdownSeconds > 0 &&
                    <div>
                      {t("totp_resend_message")} {t("totp_resend_in_message")} {
                        totp && countdownSeconds > 0 && (countdownSeconds === 60 ? 60 :`${
                          String(countdownSeconds%60).padStart(2, '0')
                        }s`)
                      }
                    </div>
                }
                {
                  countdownSeconds === 0 && 
                    <div>
                      {t("totp_resend_message")} <Link to="#"
                        onClick={() => {
                          const updatedResendRequests = resendRequests + 1;
                          if (updatedResendRequests >= 5) {
                            this.setState({ resendRequests: 0 });
                            this.props.dispatch(loginTotpFailed());
                          } else {
                            this.dispatchLogin(credentials);
                            this.setState({
                              startCountdown: updatedResendRequests === 4 ? 60 : 30,
                              resendRequests: updatedResendRequests
                            });
                          }
                        }}
                      >{t("totp_resend")}</Link>
                    </div>
                }
              </div>
          }
          {/* 
          <div className="form-group mt-3 mb-0 row">
            <div className="col-12">
              <div className="float-right">
                <Link to="#" className="text-muted">
                  {t("request_invite")}
                </Link>
              </div>
            </div>
          </div> */}
        </Form>
      </>
    );
  }
}

LoginForm = reduxForm({
  form: "login"
})(LoginForm);

const mapStateToProps = state => {
  return { user: state.user };
};
export default withRouter(
  withT(connect(mapStateToProps)(LoginForm), "login_form")
);
